import { useEffect, useState } from 'react';
import Siteinfo from './tabs/siteinfo';
import SocialMedia from './tabs/socialMedia';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { useSiteSettings, useUpdateSettings } from './api/apiSitesettings';
import { CircularProgress } from '@mui/material';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';

let twireg = /^(?:https?:\/\/)?(?:www\.)?(twitter|x)\.com\/(?:#!\/)?\w+$/;
const facreg = /(?:https?:\/\/)?(?:www\.)?(?:facebook|fb|m\.facebook)\.(?:com|me)/;
let youreg = /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)/
let instareg = /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)/


const EMAILID_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

const schema = yup.object().shape({
    siteName: yup.string().required('You must enter site name'),
    email: yup.string()
        .required('Enter contact email')
        .matches(EMAILID_REGEX, 'Enter a valid email'),
    copyrights: yup.string().required('You must enter copyrights'),
    twitter: yup.string().matches(twireg, 'Please enter a valid URL').required('Link is Required'),
    facebookUrl: yup.string().matches(facreg, 'Please enter a valid URL').required('Link is Required'),
    youtubeUrl: yup.string().matches(youreg, 'Please enter a valid URL').required('Link is Required'),
    instagramUrl: yup.string().matches(instareg, 'Please enter a valid URL').required('Link is Required'),
    favicon: yup.mixed()
        .test("required", "FavIcon is required", file => !!file)
        .required("FavIcon is required"),
    logo: yup.mixed()
        .test("required", "SiteLogo is required", file => !!file)
        .required("SiteLogo is required"),
})

const defaultValues = {
    siteName: '',
    email: "",
    copyrights: '',
    twitter: '',
    telegramUrl: '',
    favicon: "",
    logo: "",
    facebookUrl: "",
    youtubeUrl: "",
    instagramUrl: "",
    isMaintenance: false,
    isUserBuy: true,
    isUserSell: true,

}

const SiteSettings = () => {

    const { data: getsiteSetting, isLoading, isSuccess } = useSiteSettings()
    const updateSettingsmutation = useUpdateSettings();

    const methods = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    })
    const { handleSubmit, reset, resetField } = methods;

    useEffect(() => {
        if (getsiteSetting?.data) {
            reset(getsiteSetting?.data?.settings)
            resetField('twitter', getsiteSetting?.data?.settings?.socialLinks?.twitter)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess])

    const onSubmit = async (data) => {
        let formData = new FormData();
        formData.append("siteName", data.siteName)
        formData.append("email", data.email)
        formData.append("copyrights", data.copyrights)
        formData.append("twitter", data.twitter)
        formData.append("favicon", data.favicon)
        formData.append("logo", data.logo)
        formData.append("isMaintenance", data.isMaintenance)
        formData.append("facebookUrl", data.facebookUrl)
        formData.append("youtubeUrl", data.youtubeUrl)
        // formData.append("instagramUrl", data.instagramUrl)
         formData.append("telegramUrl", data.telegramUrl)
        await updateSettingsmutation.mutateAsync(formData);
    }

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'SiteSettings' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    return (
        <>
            {access ?
                <FormProvider {...methods}>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h4 className="pb-2">Settings</h4>
                        <div className="frmSbm">
                            <button onClick={handleSubmit(onSubmit)}
                                className="btn btn-primary btn-mw-132 me-2 rounded-pill"
                                disabled={isLoading || updateSettingsmutation.isLoading}
                            >
                                {isLoading || updateSettingsmutation.isLoading ? <CircularProgress style={{ color: "#fff" }} size={20} /> : "Update Settings"}
                            </button>
                        </div>
                    </div>

                    <div className="ad_pg_bx bg-white p-4">
                        <div className="row">
                            <Siteinfo getsiteSetting={getsiteSetting?.data?.settings} />
                            <hr />
                            <div className="col-sm-12 col-md-12 col-lg-10 col-xl-9 col-xxl-9">
                                <SocialMedia />
                            </div>
                        </div>
                    </div>
                </FormProvider>
                :
                <PermissionDenied />
            }

        </>
    )
}

export default SiteSettings;